import React from "react";
import { MessageCircle } from "lucide-react";
import { useSiteContent } from "@/context/SiteContentContext";

export default function WhatsAppButton() {
  const content = useSiteContent();
  const number = content?.contact?.whatsapp || "60143148627";
  const msg = content?.contact?.whatsapp_message || "您好 Charles，我想进一步了解 iSi Group。";

  if (!number) return null;

  return (
    <a
      href={`https://wa.me/${number}?text=${encodeURIComponent(msg)}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="WhatsApp Charles Lee"
      style={{ zIndex: 10000 }}
      className="fixed bottom-4 right-4 group"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-30" />
      <span className="relative flex items-center gap-3 bg-emerald-500 hover:bg-emerald-600 text-white pl-5 pr-6 py-3 rounded-full shadow-2xl shadow-emerald-500/40 transition-all duration-300 hover:scale-105 active:scale-95 min-w-[200px] min-h-[48px] justify-center">
        <MessageCircle size={20} strokeWidth={2} fill="currentColor" />
        <span className="text-sm font-semibold tracking-wide whitespace-nowrap">
          {content?.sections?.whatsapp_cta || "WhatsApp"}
        </span>
      </span>
    </a>
  );
}
